import * as FullStory from '@fullstory/browser';
import React from 'react';
import { FullStorySettings } from '../Types/FullStorySettings';

/**
 * Initializes the FullStory script.
 * @returns {boolean} fullStoryReady - Whether or not FullStory is ready to be used.
 */
const useInit = (): boolean => {
    const [fullStoryReady, setFullStoryReady] = React.useState<boolean>(false);

    React.useEffect(() => {
        const fullStorySettings: FullStorySettings = FULLSTORY_SETTINGS as FullStorySettings;

        FullStory.init(fullStorySettings, () => setFullStoryReady(true));
    }, []);

    return fullStoryReady;
};

export default useInit;
